if (!customElements.get('product-variants-modal')) {
    customElements.define('product-variants-modal', class ProductVariantsModel extends HTMLElement {
        constructor() {
            super();
            this.modalContainer = this.querySelector('.product-variants-modal')
            this.init()
            this.listenerKeydown()
        }
        init() {
            const modelOpenBtn = this.querySelector('.product-variants-modal-open')
            const modelCloseBtn = this.querySelector('.product-variants-modal-close')
            modelOpenBtn.addEventListener("click", () => {
                this.open()
            })
            modelCloseBtn.addEventListener("click", () => {
                this.close()
            })
            this.modalContainer.addEventListener("click", (element) => {
                if (element.target == this.modalContainer && this.modalContainer.classList.contains("open")) {
                    this.close()
                }
            })
        }
        listenerKeydown() {
            document.addEventListener("keydown", (e) => {
                if (
                    this.modalContainer.classList.contains("open") &&
                    e.code == "Escape"
                ) {
                    this.close();
                }
            });
        }

        open() {
            this.modalContainer.classList.add('open')
        }
        close() {
            this.modalContainer.classList.remove('open')
        }
    })
}